module.exports = __webpack_public_path__ + "media/app_search/FreeTrialExtend/images/clients/client-icon-node-ccb43d3400fb05951c89ad3ba6acd9d5.svg";